import { useState, useCallback } from 'react';
import { registerTicket } from '../services/ticketService';

/**
 * Hook to manage ticket registration
 */
export function useTicketRegistration(eventSlug) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ticket, setTicket] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const register = useCallback(
    async ({ lastName, email, adults, children }) => {
      setIsLoading(true);
      setError(null);
      setTicket(null);

      try {
        const result = await registerTicket({
          eventSlug,
          lastName,
          email,
          adults,
          children,
        });

        if (result.success) {
          setTicket(result.ticket);
          setIsSuccess(true);
          return { success: true, ticket: result.ticket };
        } else {
          setError({
            code: result.error,
            message: result.message,
          });
          return { success: false, error: result.error };
        }
      } catch (err) {
        const errorData = {
          code: err.error || 'network_error',
          message: err.message || 'Erreur de connexion. Veuillez réessayer.',
        };
        setError(errorData);
        return { success: false, error: errorData.code };
      } finally {
        setIsLoading(false);
      }
    },
    [eventSlug]
  );

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setTicket(null);
    setIsSuccess(false);
  }, []);

  return {
    register,
    reset,
    isLoading,
    error,
    ticket,
    isSuccess,
  };
}
